export enum MODAL_TYPES {
  WRONG_NETWORK_MODAL = 'WRONG_NETWORK_MODAL',
  BACK_MODAL = 'BACK_MODAL',
  ADVANCED_FILTERS = 'ADVANCED_FILTERS',
  VAULT_INFORMATION = 'VAULT_INFORMATION',
  NFT_MODAL = 'NFT_MODAL',
  PRICE_IMPACT_MODAL = 'PRICE_IMPACT_MODAL',
  CHANGE_PROFIT_TOKEN_MODAL = 'CHANGE_PROFIT_TOKEN_MODAL',
  VAULTS_VIDEO_MODAL = 'VAULTS_VIDEO_MODAL',
  FIND_FARM_MODAL = 'FIND_FARM_MODAL',
  MANAGE_LIQUIDITY_MODAL = 'MANAGE_LIQUIDITY_MODAL',
  CREATED_VAULT_MODAL = 'CREATED_VAULT_MODAL',
  ACCOUNT_MODAL = 'ACCOUNT_MODAL',
  CONNECT_WALLET_MODAL = 'CONNECT_WALLET_MODAL',
  CHAIN_MODAL = 'CHAIN_MODAL',
  ADD_REQUEST_MODAL = 'ADD_REQUEST_MODAL',
}

export const INITIAL_MODAL_STATE = {
  current: null,
  props: null,
};
